(function () {
  'use strict';

  var productSection = document.querySelector('[data-product-section]');
  if (!productSection) return;

  function buildUrl(productUrl, sectionId, variantId) {
    var url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('sections', sectionId);
    return url.toString();
  }

  function refreshProductSection(variantId, section) {
    if (!variantId) return Promise.resolve();

    return fetch(buildUrl(section.dataset.productUrl, section.dataset.sectionId, variantId))
      .then(function (response) {
        if (!response.ok) throw new Error('Section render failed: ' + response.status);
        return response.json();
      })
      .then(function (fragments) {
        var html = fragments[section.dataset.sectionId];
        if (!html) return;

        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var fresh = wrapper.querySelector('[data-product-section]');
        if (!fresh) return;

        section.innerHTML = fresh.innerHTML;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState(null, '', url.toString());
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-option-value]');
    if (!button || button.disabled) return;

    var option = button.closest('[data-option-index]');
    var section = button.closest('[data-product-section]');
    if (!option || !section) return;

    event.preventDefault();

    var input = option.querySelector('[data-option-input]');
    if (input) input.value = button.getAttribute('data-option-value');

    option.querySelectorAll('[data-option-value]').forEach(function (b) {
      var active = b === button;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var variantId = button.getAttribute('data-variant-id');
    var idInput = section.querySelector('[data-variant-id-input]');
    if (idInput && variantId) idInput.value = variantId;

    refreshProductSection(variantId, section).catch(function (error) {
      console.error('Variant update failed', error);
    });
  });
})();

(function () {
  'use strict';

  var header = document.querySelector('.site-header');
  if (!header) return;

  var toggle = header.querySelector('.nav-toggle');
  var menu = header.querySelector('#mobile-menu');
  if (!toggle || !menu) return;

  function setOpen(open) {
    header.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    var label = toggle.querySelector('.nav-toggle__label');
    if (label) label.textContent = open ? 'Close' : 'Menu';
    menu.hidden = !open;
  }

  toggle.addEventListener('click', function () {
    setOpen(menu.hidden);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !menu.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  menu.addEventListener('click', function (event) {
    if (event.target.closest('a') || event.target.closest('button')) {
      setOpen(false);
    }
  });
})();
